




















































import { Vue, Component, Prop, Watch, Ref } from 'vue-property-decorator'
import { QInput } from 'quasar'
import api from 'src/assets/api/rest'
import { signIn } from 'src/boot/auth'
import DeadlineTimer from 'components/DeadlineTimer.vue'

@Component({
  components: { DeadlineTimer }
})
export default class AuthCodeInput extends Vue {
  email = ''
  code = ''
  action = ''
  beginTime: Date = new Date()
  validTime: Date = new Date()
  loading: boolean = false
  error: boolean = false

  @Prop(Response)
  readonly response!: Response

  get isCodeValid(): boolean {
    return this.code.length === 6 && this.validTime && new Date(this.validTime) > new Date()
  }

  @Watch('validTime')
  resetCode(newValue: Date): void {
    if (newValue === null) {
      this.code = ''
    }
  }

  @Ref()
  readonly input!: QInput

  async created () {
    const data = await this.response.json()
    this.email = data.value
    this.action = data.action
    this.validTime = new Date(data.validTime)
  }

  async singIn () {
    if (this.isCodeValid) {
      this.loading = true
      try {
        const response = await api.post('/api/sign-in/email-code', {
          email: this.email,
          code: this.code,
          action: this.action,
          locale: this.$i18n.locale,
          timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
        })
        const accessToken = await response.text()
        signIn(accessToken)
        this.$emit('signin')
      } catch (e) {
        this.error = true
        setTimeout(() => {
          this.code = ''
          this.error = false
          this.input.focus()
        }, 500)
      }
      this.loading = false
    }
  }

  async codeRefresh () {
    this.beginTime = new Date()
    this.loading = true
    const response = await api.post('/api/sign-in/email', {
      email: this.email,
      locale: this.$i18n.locale,
      newcode: true
    })
    const data = await response.json()
    this.email = data.value
    this.action = data.action
    this.validTime = new Date(data.validTime)
    this.loading = false
    this.code = ''
    this.$nextTick(() => {
      this.input.focus()
    })
  }
}
